import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import { Grid } from 'syf-component-library/ui/patterns';
import { Image } from './styled';
export const MiniCardsWrapper = styled(Grid) `
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: ${spacing.small}px;
`;
export const MiniCard = ({ url, key, alt, ariaHidden, testId }) => {
    return (_jsx(Image, { alt: alt, "aria-hidden": ariaHidden, "data-testid": testId, src: url }, key));
};
export const MiniCards = ({ miniCards }) => {
    return (_jsx(_Fragment, { children: Object.values(miniCards).map(({ url, id, altText, ariaHidden }) => (_jsx(MiniCard, { alt: altText, ariaHidden: ariaHidden, url: url }, id))) }));
};
